
import ModuleManager from "../../../../../../framework/core/module_manager";;
import SceneManager from '../../../../../../manager/scene_manager';
import ModelData from "../../../../../public/model_data";
import LanguageManager from "../../../../../../manager/language_manager";
import { JdTableEntityBase } from "./jd_table_entity_base";
import { JdConst } from "../../data/jd_define";
import { JdSeatEntity } from "../seat/jd_seat_entity";
import { JdHelp } from "../../help/jd_help";
import { JdTableData } from "../../data/jd_table_data";
import { Jd } from "../../../../net/proto/proto_jd_game";
import { JdRoom } from "../../../../net/proto/proto_jd_room";
import TexasSound from "../../../../../texasholdem/module/texas_sound";
import { Define } from "../../../../../texasholdem/module/table/data/const_define";
import { TableHelp } from "../../../../../texasholdem/module/table/help/table_help";
import UserDataManager, { IUserCurrencyData } from "../../../../../../manager/user_manager";
import Utility from "../../../../../../utility/utility";
import EventManager from "../../../../../../manager/event_manager";
import { joinUtil } from "../../../../../public/join_util";
//ui公共层
export class JdTableEntity extends JdTableEntityBase{

    private isCreate = false;//游戏是否构建完成

    onViewInited(){
        super.onViewInited();
        this.viewBase.addBet.on('click',this.addBetCallBack,this);
        this.viewBase.heguan.on('click',this.addBetCallBack,this);
        EventManager.instance.on('show_emoji_msg',this.showEmogiMsg,this,true);
        EventManager.instance.on('Event_Update_PaiBei',this.updatePaiBei,this,true);
        this.dealerState(false)
        this.emit(JdConst.updateUI,' ');
    }

    onCreate(){}

    //游戏初始化执行
    initGame(protoData:Jd.IGameInfo){
        if (this.isCreate) {
            return;
        }
        this.isCreate = true;
        super.initGame(protoData);
        this.viewBase.setSeatNumb(this.tableSeatNumb);//设置座位数
        this.createSeatClickNode();
        this.createSeatEntity();
    }


    createSeatEntity(){
        for (let i = 0; i < this.tableSeatNumb; i++) {
            let seatBase = new JdSeatEntity();
            this.seatEntityBase[i] = seatBase;
            seatBase.operatorFunc = this.sendAck.bind(this);
            seatBase.Init(this.viewBase.seatRoot,this);
        }
    }

    private seatID = 0
    clickSeatBtn(btn:cc.Button){
      
    }

    //创建可点击的座位
    createSeatClickNode(){
        //创建座位
        this.seatNode = this.seatNode || [];
        for (let i = 0; i < this.tableSeatNumb; i++) {
            let seatNode = this.viewBase.addSeat(i);
            this.seatNode[i] = seatNode;
            seatNode.active = false;
            //seatNode.on('click',this.clickSeatBtn,this)
        }
    }

    onRevGameInfo(protoData:Jd.IGameInfo){
        super.onRevGameInfo(protoData);

        this.initGame(protoData);

        this.onUserActive();

        this.refreshPlayerSeatUI();


        this.refreshTableUI(protoData);
    }

    onUserActive(){
        this.viewBase.updatePoker(ModelData.instance.roleData.id);
        this.seatData.forEach((data:JdTableData.SeatPlayerData)=>{
            if (data) {
                let viewID = this.getViewID(data.seat_id);
                if (viewID != -1) {
                    this.getSeatEntity(viewID,(e:JdSeatEntity)=>{
                        e.onUserActive();
                    });;
                }
            }
        })
    }

    refreshTableUI(protoData:Jd.IGameInfo){
        //更新下注额
        this.isShowHand = true;
        this.emit(JdConst.updateUI,protoData.roundId);
        if (protoData.state == 5) {
            this.reset();
        }else if(protoData.state != 0) {
            this.setDealer(protoData.bankerSeatId);
            this.refreshPot(protoData.pot);
            this.viewBase.updateSidePot(protoData.poolList);
            let entitys = this.inGameSeatEntity()
            for (let entity of entitys) {
                entity.beginGame(protoData);
            }
            //更新我方
            let myEntity = this.getEntityServerID(this.selfServerSeatID);
            if (myEntity) {
                myEntity.beginGame(protoData);
            }
            if (this.isSelfPlaying() 
                && (protoData.state == 2 || protoData.state == 4)) {
                this.updateSetting(protoData.currentSeat,protoData.currentLevelBet);
            }else{
                this.emit(JdConst.refreshUI,null);
            }
            this.showCardsType()//重连
        }else{
            if (protoData.state == 0) { //清理牌桌 并且倒计时
                this.checkBetCallBack();
                this.reset();
                this.gameOverCountdown(protoData.stateExpiredTime-protoData.time);                
            }
        }

        this.viewBase.tableDes(protoData.roomId,this.commonData.game_BetMin);
    }

    //定庄
    bankerNotify(protoData:Jd.BankerNotify){
        super.bankerNotify(protoData);
        this.setDealer(protoData.seatId);
    }

    //归池通知
    betPoolNotify(proto:Jd.BetPoolNotify){
        //更新边池
        this.viewBase.updateSidePot(proto.poolList);
        //归池动画
        for (let st of this.seatEntityBase) {

            st.guiChi(this.viewBase.checkBetNode,()=>{
                JdHelp.delay(this.viewBase.addBet,()=>{
                    if (proto.seatList.length > 0) {
                        this.initPlayers(proto.seatList);
                        this.refreshPlayerSeatUI();
                    }
                    this.modeBase.send_ack();
                },0.1)
            });

            if (!st.checkIsGuiChi()) {
                this.commonData.isNeedWaite = false;
            }

            st.roundOver();
            st.setBetState(false)//隐藏
        }
        super.betPoolNotify(proto);
    }

    carryWantsNotify(proto:Jd.ICarryWantsNotify){
        super.carryWantsNotify(proto);
        this.addBetCallBack();
    }

    //发牌通知
    dealCardNotify(proto:Jd.IDealCardNotify){
        super.dealCardNotify(proto);
        this.viewBase.isShowCountDown(false)//发牌取消倒计时
        if (proto.dealCnt == 2) {//发两张
            this.dealCardsAction(0,2)
        }else if(proto.dealCnt == 3) {//以发2张
            this.dealCardsAction(2,3)
        }
    }

    private isShowHand = true;
    //结算通知
    gameSettle(proto:Jd.IGameSettle){

        super.gameSettle(proto);


        if (proto.seatList.length > 0) {
            this.refreshPlayerSeatUI();
        }


        let entitys = this.inGameSeatEntity();
        for (let et of entitys) {
            et.showSmallCards();
        }

        //1.亮牌
        if (this.isShowHand) {
            this.emit(JdConst.refreshUI,null);
            for (let seat of proto.seatList) {
                if (seat.state != 0
                    && seat.state != 8) {
                    this.showVictory(proto);
                    if (proto.reason == 0) {
                        this.BrightHands(seat.seatId,seat.cards,seat.cardType,seat.cardPoint);
                    }
                }
            }

            this.isShowHand = false; 
        }

        this.commonData.sidePotIndex = 0;
        JdHelp.delay(this.dealerNode,()=>{
            let myEntity = this.getEntityServerID(this.selfServerSeatID);
            if (myEntity) {
                EventManager.instance.dispatch('Game_Table_Settlement',myEntity.effectNode)
            }
            this.startHandleSidePots(proto);
        },Define.lightHandsTime)
    }

    //显示胜利
    private showVictory(gameSettlement:Jd.IGameSettle){
        let players =gameSettlement.seatList;
        let isWin = false;
        if (players) {
            let isFold = gameSettlement.reason == 1;
            for (let player of players) {
                if (player.state != 0
                    && player.state != 8) {
                        let isWinner = player.balance > 0;
                        let entity = this.getEntityByPlayerID(player.playerId);
                        if (this.isRole(player.playerId)) {
                            isWin = isWinner;
                        }
                        if (entity) {
                            entity.isWinner = isWinner;//是否获胜
                            if (isWinner) {
                                entity.delayShowWinAnim(player,isFold,()=>{
                                    if (this.isRole(player.playerId)) {
                                        let mySelf = this.getEntityServerID(this.selfServerSeatID);
                                            if (mySelf && mySelf.isPlayingGame()
                                            && !mySelf.isFold()) {
                                                if (mySelf.isWinner) {
                                                    TexasSound.bipaiwin();
                                                }else{
                                                    TexasSound.bipailose();
                                                }
                                            }
                                    }
                                });
                            }
                        }
                }
            }
            let mySelf = this.getEntityServerID(this.selfServerSeatID);

            if (mySelf && mySelf.isPlayingGame()
            && !mySelf.isFold()) {
                if (!isWin) {
                    TexasSound.bipailose();
                }
            }
        }
    }

    private checkLeaveGame(){
        if (ModelData.instance.tableCommonData.autoLeaveWhenGameEnd) {
            this.req_leaveRoom();
        }
    }

    private checkBetCallBack(){
        let info = this.getPlayerSeatData();
        if (info && info.coin_balance <= 0) {
            //this.addBetCallBack();
        }
    }

    private startHandleSidePots(settlement:Jd.IGameSettle){
        let poolList = settlement.poolList;
        if (!poolList) {
            return;
        }

        this.dealerNode.stopAllActions();
        let poolCount = settlement.poolList.length;
        TableHelp.repeatTimesAction(this.dealerNode,1.2,poolCount,()=>{
            this.doSidePotAction(poolList,settlement)
        })
    }

    private doSidePotAction(poolList:Jd.GameSettle.IPoolSettle[],settlement:Jd.IGameSettle){
        this.sidePotAction(settlement);
        if (poolList.length > 0) {
            if (this.commonData.sidePotIndex == poolList.length) {
                this.dealerNode.stopAllActions();
            }
        }else{
            this.dealerNode.stopAllActions();
        }
    }

    private sidePotAction(proto:Jd.IGameSettle){
        if (!proto.poolList) {
            return;
        }
        let doGames = this.inGameSeatEntity();//参与此牌局玩家
        for (let entity of doGames) {
            entity.startHandlSidePot();
        }
        
        let poolData = proto.poolList[this.commonData.sidePotIndex];
        if (!poolData) {
            this.dealerNode.stopAllActions();
            return;
        }

        //2.处理赢家
        let entity = this.getEntityServerID(poolData.winnerSeatId);
        if (entity) {
            //1.显示最大牌型

            //2.飞筹码
            let sidePool = this.viewBase.sidePool;
            let pool = sidePool.getPoolData(this.commonData.sidePotIndex);
            if (pool) {
                sidePool.recycleOneSidePot(this.commonData.sidePotIndex);
                let chips = JdHelp.getRightMount(poolData.winCoin);
                entity.obtainBet(pool.target,chips,()=>{
                    //延迟0.1
                    this.commonData.sidePotIndex++;
                    if (proto.poolList) {
                        if (this.commonData.sidePotIndex >= proto.poolList.length) {
                            JdHelp.delay(this.viewBase.addBet,()=>{
                                this.reset();//最后一个池清理
                                this.modeBase.send_ack();
                                cc.log('-->>>延时发送ACK');
                            },2)
                        }
                    }else{
                        cc.log('-->>>发送ACK');
                        this.reset();
                        this.modeBase.send_ack();
                    }
                });
            }
        }
    }

    playGameOverSound(winner:JdSeatEntity){
        if (winner.isMySelf) {//是我自己
            TexasSound.bipaiwin();
        }else{
            let myEntity = this.getEntityServerID(this.selfServerSeatID);
            if (myEntity) {
                if (myEntity.isPlayingGame()) {
                    TexasSound.bipailose();
                }
            }
        }
    }

    //定时器通知
    timeoutNotify(proto:Jd.ITimeoutNotify){
        super.timeoutNotify(proto);
        if (proto.event == 2 
            || proto.event == 4) {
            //当前操作的玩家
            this.timeOutDoAction(proto);
        }

        if (proto.event == 888) {

        }

        if (proto.event == 0) { //清理牌桌 并且倒计时
            this.reset();
            this.gameOverCountdown(proto.timeout);
        }

        if (proto.event == 8) {//倒计时的事件
            this.reset();
            this.gameOverCountdown(proto.timeout);
            //自动离开检测
            this.checkLeaveGame();
            EventManager.instance.dispatch('Game_Table_Start')
        }
    }

    carryCoinNotify(proto:Jd.ICarryCoinNotify){
        super.carryCoinNotify(proto);
        let entity = this.getEntityServerID(proto.seatId);
        if (entity) {//实体
            let seatData = entity.seatData;
            if (seatData) {
                let old = seatData.coin_balance;
                seatData.account_balance = proto.accountBalance;
                seatData.coin_balance = proto.coin;
                if (Math.abs(old - proto.coin) >= 0.1) {
                    entity.updateEntityChips(old); 
                }
            }
        }
    }

    betNotify(proto:Jd.IBetNotify){
        super.betNotify(proto)
        if (proto.seatId == 0) {
            return;
        }

        let entity = this.getEntityServerID(proto.seatId);
        if (entity) {
            entity.updatePlayerState(proto,()=>{
                this.sendAck();
            });
        }

        this.refreshPot(proto.pot);
        this.viewBase.isShowCountDown(false)
    }

    timeOutDoAction(proto:Jd.ITimeoutNotify){
        if (proto.seatId != 0) {
            for (let entity of this.inGameSeatEntity()) {
                entity.hideOpTimeState();
            }
            let entity = this.getEntityServerID(proto.seatId);
            if (entity) {
                entity.setOpTime(proto.timeout,proto.totalTimeout);
            }
            this.updateSetting(proto.seatId,proto.param);
        }
    }

    showPattern(cardType:number,cardPoint:number){
        if (this.isSelfPlaying()) {
            this.viewBase.showCardsType(cardType,cardPoint);
        }
    }

    private updateSetting(seatId:number,param:number){
        let myData = this.getPlayerSeatData();
        if (myData && (myData.state == 0
            || myData.state == 7
            || myData.state == 8)) {
            this.emit(JdConst.refreshUI,null);
            return;
        }
        if (seatId == this.selfServerSeatID) {
            this.settingData.params = param;
            this.settingData.chips = myData.coin_balance;
            if (this.settingData.autoCheck != undefined
                && this.settingData.autoCheck == JdTableData.AutoSetting.None) {
                this.settingData.isMyRound = true;
            }else{//有自动操作
                let callBet = this.commonData.maxBet - myData.bet;//新的跟注
                let old = this.settingData.mount;
                this.settingData.mount = callBet
                if (callBet > old
                    && this.settingData.autoCheck == JdTableData.AutoSetting.Auto_Check) {
                        this.settingData.isMyRound = true;
                }else{
                    this.autoOperator();
                }
            }
            this.settingData.autoCheck = JdTableData.AutoSetting.None;//取消选定
            this.settingData.mount = JdHelp.getRightMount(this.commonData.maxBet - myData.bet) || 0;
            this.emit(JdConst.refreshUI,this.settingData);
        }else{
            let isPlaying = this.isSelfPlaying()
            if (isPlaying) {
                this.settingData.isMyRound = false
                this.settingData.chips = myData.coin_balance;
                if (myData) {
                    if (myData.bet >= this.commonData.maxBet) {
                        this.settingData.mount = 0;
                    }else{
                        let old = this.settingData.mount;
                        this.settingData.mount = this.commonData.maxBet - myData.bet;
                        if (this.settingData.mount > old
                            && this.settingData.autoCheck == JdTableData.AutoSetting.Auto_Check) {
                            this.settingData.autoCheck = JdTableData.AutoSetting.None;//取消选定
                        }
                    }
                    this.emit(JdConst.refreshUI,this.settingData);
                }
            }else{
                this.emit(JdConst.refreshUI,null);
            }
        }
    }

    autoOperator(){
        let autoCheck = this.settingData.autoCheck;

        let isCheck = this.settingData.params == 0;//是否可以让牌

        if (autoCheck == JdTableData.AutoSetting.Chek_Pass) {//自动过或者弃牌
            //检查是否可以过
            if (isCheck) {
                cc.log('--->>自动过牌');
                this.modeBase.send_BetRsp(0);
            }else{
                cc.log('--->>自动弃牌');
                this.modeBase.send_foldRsp();
            }
        }

        //自动过牌
        if (autoCheck == JdTableData.AutoSetting.Auto_Check) {
            //-让牌
            if (isCheck) {
                this.modeBase.send_BetRsp(0);
                cc.log('执行自动过牌操作');
            }else{
                this.modeBase.send_BetRsp(this.settingData.params);
                cc.log('执行跟牌操作');
            }
        }

        if (autoCheck == JdTableData.AutoSetting.Any_Call) {
            //跟任何注 判断余额 和 跟注额的大小,是否可以跟
            let data = this.findSeatInfoBySeatID(this.selfServerSeatID);
            if (data) {
                let isCall = data.coin_balance > this.settingData.params;
                if (isCall) {//是否可以跟
                    cc.log('执行跟操作');
                    this.modeBase.send_BetRsp(this.settingData.params);
                }else{
                    if (isCheck) {
                        this.modeBase.send_BetRsp(0);
                        cc.log('执行让牌操作');
                    }else{
                        cc.log('自动执行All-IN操作');
                        this.modeBase.send_BetRsp(data.coin_balance,true);
                    }
                }
            }
        }
    }

    //弃牌广播
    foldNotify(proto:Jd.IFoldNotify){
        super.foldNotify(proto);
        let entity = this.getEntityServerID(proto.seatId);
        if (entity) {
            entity.foldOperator(false);
        }
    }

    //亮牌
    BrightHands(pos:number,cards:number[],type:number,point:number){
        let entity = this.getEntityServerID(pos);
        entity.showEndHands(cards,type,point);
    }

    playerEnterRoom(){
        this.refreshSeatVisible();
    }

    private refreshPlayerSeatUI(){
        this.seatData.forEach((data:JdTableData.SeatPlayerData)=>{
            if (data) {
                this.playerSitDownSeatID(data.seat_id);
            }
        })

        this.refreshSeatVisible();
    }

    //更新总池
    protected refreshPot(pot:number){
        if (pot != undefined && pot > 0) {
            this.viewBase.setPotNumb(pot);//大于零才显示
        }
    }

    //更新座位的状态显示
    protected refreshSeatVisible(){
        if (this.selfServerSeatID == 0) {//自己离开
            for (let seat of this.seatEntityBase) {
                let viewID = this.getViewID(seat.serverSeatID);
                let seatNode = this.seatNode[viewID];
                seatNode.active = false//!seat.isSeat;
            }
        }else{//自己坐下
            // for (let seat of this.seatNode) {
            //     seat.active = false;
            // }

            this.seatEntityBase.forEach((seat:JdSeatEntity)=>{
                let viewID = this.getViewID(seat.serverSeatID);
                let seatNode = this.seatNode[viewID];
                seatNode.active = !seat.isSeat;
            })
        }

        this.checkSeekPlayers();

        cc.log('-------------------refreshSeatVisible');
    }

    setDealer(seatID:number){
        let viewID = this.getViewID(seatID);
        if (viewID == -1) {
            return;
        }
        let isAnim = false;
        if (this.viewBase.dealer.active) {
            isAnim = true;
        }
        let seatInfo = this.seatInfo[viewID];

        if (seatInfo) {
            let endPos = seatInfo.dealer;
            let node = this.viewBase.dealer;
            node.stopAllActions();
            node.active = true;
            if (isAnim) {
                JdHelp.moveToAction(node,endPos,0.6);
            }else{
                node.position = endPos;
            }
        }
    }

    dealerState(isShow:boolean){
        this.viewBase.dealer.active = isShow;
    }

    throwCardsAction(){
        this.viewBase.throwCardsAction();
    }


    //发牌 D为中心 顺时针发牌 showCards 显示几张 haveCards 已经显示的牌
    dealCardsAction(haveCards:number,showCards:number,cards?:number[]){
        let doActions = this.inGameSeatEntity(true);//参与游戏中的entity[this.getEntityServerID(this.selfServerSeatID)]//
        let count = doActions.length
        if (count <= 0) {//未参与游戏
            return;
        }
        for (let ac of doActions) {
            ac.beginDealCards(haveCards);//开始发牌
        }
        if (this.isSelfPlaying()) {
            this.viewBase.beginDealCards(haveCards);
        }

        this.viewBase.chatNode.stopAllActions();
        let index = 0;
        let cardIndex = haveCards;
        let repeatTimes = count * (haveCards == 0 ? 2:1) + 1//翻牌结束
        JdHelp.scheduleTimes(this.viewBase.chatNode,()=>{
            if (index == count) {
                index = 0;
                if (cardIndex < showCards-1) {
                    cardIndex++;
                }else{
                    if (showCards != 3) {
                        this.viewBase.chatNode.stopAllActions();
                        JdHelp.delay(this.viewBase.chatNode,()=>{
                            this.viewBase.dealOverCards(haveCards,showCards,()=>{
                                this.modeBase.send_ack();
                                this.showCardsType();//更新牌型
                            },this.isSelfPlaying());
                        },0.4)
                    }
                    return;
                }
            }
            let present = doActions[index];
            if (present) {
                if (present.isMySelf) {
                    let data = present.seatData;
                    if (data) {
                        if (data.state != 8) {
                            this.viewBase.dealCardsMySelf(cardIndex,data.cards,this.isSelfPlaying(),()=>{
                                JdHelp.delay(this.viewBase.chatNode,()=>{
                                    this.modeBase.send_ack();
                                    this.showCardsType();//更新牌型
                                },0.4)
                            });
                        }
                    }
                }else{
                    present.dealCards(this.viewBase.dealerNode,cardIndex);
                }
            }
            index++;
        },0.08,repeatTimes);
    }

    //检测寻找玩家
    checkSeekPlayers(){
        if (this.modeBase.seatData) {
            if (this.modeBase.seatData.length >= this.commonData.minJoinPeople) {
                EventManager.instance.dispatch('update_seek_player',0,0)
            }else{
                if (this.isHavePlayerInGame()) {
                    EventManager.instance.dispatch('update_seek_player',0,0)
                }else{
                    EventManager.instance.dispatch('update_seek_player',this.modeBase.seatData.length,this.commonData.minJoinPeople)
                }
            }
        }else{
            EventManager.instance.dispatch('update_seek_player',0,0)
        }
    }

    gameOverCountdown(time:number){
        if (time <= 0) {//小于零无需弹框
            //取消弹框
            this.viewBase.isShowCountDown(false)
            this.viewBase.addBet.stopAllActions();
            return;
        }
        this.viewBase.addBet.stopAllActions();
        this.viewBase.isShowCountDown(true)
        this.viewBase.updateCountDwon(time);
        JdHelp.schedule(this.viewBase.addBet,()=>{
            time--;
            if (time <= 0) {
                this.viewBase.isShowCountDown(false)
                this.viewBase.addBet.stopAllActions();
            }else{
                this.viewBase.updateCountDwon(time);
            }
        },1)
    }

    stopActions(){
        this.viewBase.addBet.stopAllActions();
        this.dealerNode.stopAllActions();
    }

    //重置
    reset(){
        super.reset();
        this.stopActions();
        this.viewBase.reset();
        this.emit(JdConst.refreshUI,null);
        //重置座位
        if (this.seatEntityBase) {
            for (let seatEntity of this.seatEntityBase) {
                seatEntity.reset();
                seatEntity.hideCheckGold();//金币独立显示
            } 
        }
        this.isShowHand = true;
        this.refreshSeatVisible();
    }

    leaveBroadcast(protoData:JdRoom.ILeaveBroadcast){
        if (!this.isRole(protoData.playerId)) {
            let entity = this.getEntityByPlayerID(protoData.playerId);
            if (entity) {
                if (entity.seatData) {
                    this.playerStandUpSeatID(entity.seatData.seat_id)
                }
                entity.leaveGame(protoData.playerId);
            }
        }else {

            if (!joinUtil.checkLeave(protoData.reason,this.mvvBase)) {

                this.exitTable();
            }
            
        }
        super.leaveBroadcast(protoData);
        this.refreshSeatVisible();//离开刷新状态
    }

    carryCoin(proto:Jd.ICarryCoinRsp){
        if (proto.errNo == 0) {//携带成功
            let entity = this.getEntityServerID(this.selfServerSeatID);
            if (entity) {
                let seatData = this.getPlayerSeatData();
                cc.log('--------------->>>玩家状态',seatData.state)
                if (seatData && (seatData.state == JdConst.SeatState.fold
                    || seatData.state == JdConst.SeatState.NoFight)) {
                    let old = seatData.coin_balance;
                    seatData.coin_balance = this.commonData.carryCoin;
                    entity.updateEntityChips(old);
                }else{
                    ModuleManager.instance.toastKey('jd_info_next_update');
                }
            }
        }
        super.carryCoin(proto);
        cc.log('--->>>carrycoin',proto.errNo);
    }

    addBetCallBack(btn:cc.Node = null,endTips:boolean=false){//游戏中补充筹码
        let self = this
        Utility.playButtonSound();
        let seatData = this.findSeatInfoBySeatID(this.selfServerSeatID);
        if (seatData) {
            cc.log('-->>>>>>>>>>>>account_balance',seatData.account_balance);
            let account_balance = seatData.account_balance || 0;
            let coin = 0;//seatData.coin_balance || 0;//临时处理-待服务器更新完成去掉coinbalance
            let total = coin + account_balance;
            if (total <= 0) {
                ModuleManager.instance.toastKey('server_error_-41');
            }else{
                self.openTexasChips(endTips,total);
            }
        }
    }

    private openTexasChips(endTips:boolean=false,account:number){
        let self = this;
        let func = (data:number,isChange:boolean,progress:number)=>{
            let pData = this.getPlayerSeatData();
            if (pData && pData.coin_balance == data) {//补充的与余额相等无需发送协议
                
            }else{
                this.commonData.carryCoin = data;//携带金币
                self.modeBase.send_carrayCoin(data,isChange);
            }
            this.commonData.progress = progress;
        }
        let endCallFunc = (progress:number)=>{
            if (endTips) {
                ModuleManager.instance.toastKey(JdConst.OpTips[7]);
            }
            this.commonData.progress = progress;
        }
        let pData = this.getPlayerSeatData();
        let lockGold = pData.coin_balance;
        let data = {
            lockGold:lockGold,
            min:this.commonData.min_join_coin,
            max:this.commonData.max_join_coin,
            callFunc:func,
            colseCallBack:endCallFunc,
            progress:this.commonData.progress,
            coinbalance:account,
        }
        ModuleManager.instance.showModuleName('JdChips',data);
    }

    showEmogiMsg(arg1,arg2:any,arg3:any){
        if (arg2 && arg3) {
            let id = arg2.playerId;
            let type = arg2.chatMsg.msgType;
            let content = arg2.chatMsg.text
            if (type == 8) {
                let entity = this.getEntityByPlayerID(id);
                if (entity && cc.isValid(entity.effectNode)) {
                    entity.setDebugInfo(content);
                }
            }
        }
    }

    updatePaiBei(uid:number){
        if (uid == ModelData.instance.roleData.id) {
            this.viewBase.updatePoker(uid);
        }else{
            let entity = this.getEntityByPlayerID(uid);
            if (entity) {
                entity.updatePoker(uid);
            }
        }
    }


    //清理工作
    clear(){
        this.reset();
        this.viewBase.clear();
        for (let et of this.seatEntityBase) {
            et.clear();
        }
    }

    removeEvent(){
        EventManager.instance.off('show_emoji_msg',this.showEmogiMsg,this)
        EventManager.instance.off('Event_Update_PaiBei',this.updatePaiBei,this)
    }

    //离开牌局
    exitTable(){
        super.exitTable();
        this.clear();
        this.removeEvent();
        SceneManager.gotoHallOrClubHall("TabelExit");
    }


}
